module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAABFUlEQVQokYWSvSuGYRTGf97ebEyyGi1KETYjysCd0WTgniSDr7/AoIxyShkkixzZbEqZTCysFgYTsUiPzvN5Xj0v13au61zn6747kiShRIiLwDwwADSAe+AElf0ipTKEeA7MUI9LVKbIq1jy8R/JhklCPM06zC4NA7dOfAN2gS9gBej1xiaw5ohPYBSVx7zzIXAH9OT6ho005gxaJqeRPAMHTu83Q6cjumvm91zTDC+OmCbEkTIKcRBYcPqH7XABDOWEFbghxD3gG1i2qs5wbVfqAl5/jdYOfQ1U3tM7/485VJ6yh1O5Son2WEflrJi5OKERqzWeI1R2iqD182WX2QY2iyVRGfdy1aHqtJX+UHgAJlo04AdXY0qABqSuFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon1.png
// module id = d0yY
// module chunks = 0